import { SET_LOADING } from '../common/commonTypes'
import {
  ACTIVE_TRIPS_REQUEST,
  DRAFT_TRIPS_REQUEST,
  CONFIRM_TRIPS_REQUEST,
  BOOKING_LIST_REQUEST,
  SET_TRAVELER_FILTER,
  SET_HOST_FILTER,
  SET_ORGANIZARIONS,
  SET_PROJECTS,
} from './types'
import {
  getPrivateTripList,
  fetchBookingRequests,
  APIS,
} from '@/utils/apiEndpoints'

export const fetchActiveTrips =
  (params = {}) =>
  async (dispatch) => {
    try {
      dispatch({ type: SET_LOADING, payload: true })
      const resp = await APIS.activeProjects({
        limit: 500,
        page: 0,
        sortBy: 'startDate',
        ...params,
      })
      const active = []
      const canceled = []
      const completed = []
      resp.result.data &&
        resp.result.data?.map((trip) => {
          switch (trip?.status) {
            case 'created':
            case 'draft':
            case 'published':
              active.push(trip)
              break
            case 'completed':
              completed.push(trip)
              break
            case 'canceled':
            case 'cancelled':
              canceled.push(trip)
              break
          }
        })
      dispatch({
        type: ACTIVE_TRIPS_REQUEST,
        payload: [...active, ...canceled, ...completed],
      })
    } catch (error) {
      dispatch({ type: ACTIVE_TRIPS_REQUEST, payload: false })
    } finally {
      dispatch({ type: SET_LOADING, payload: false })
    }
  }

export const fetchDraftTrips =
  (params = {}) =>
  async (dispatch) => {
    try {
      dispatch({ type: SET_LOADING, payload: true })
      const resp = await getPrivateTripList({
        status: 'draft',
        limit: 100,
        page: 0,
        sortBy: 'startDate',
        ...params,
      })
      dispatch({ type: DRAFT_TRIPS_REQUEST, payload: resp.result.data })
    } catch (error) {
      dispatch({
        type: DRAFT_TRIPS_REQUEST,
        payload: false,
      })
    } finally {
      dispatch({ type: SET_LOADING, payload: false })
    }
  }
export const loadOrganizations = () => async (dispatch) => {
  try {
    dispatch({ type: SET_LOADING, payload: true })
    const resp = await APIS.listOrganizations()
    dispatch({ type: SET_ORGANIZARIONS, payload: resp.result })
  } catch (error) {
    dispatch({ type: SET_ORGANIZARIONS, payload: false })
  } finally {
    dispatch({ type: SET_LOADING, payload: false })
  }
}

export const loadProjects = (organizationId) => async (dispatch) => {
  try {
    dispatch({ type: SET_LOADING, payload: true })
    const resp = await APIS.listOrganizationProjects(organizationId)
    dispatch({ type: SET_PROJECTS, payload: resp.result.data })
  } catch (error) {
    dispatch({ type: SET_PROJECTS, payload: false })
  } finally {
    dispatch({ type: SET_LOADING, payload: false })
  }
}
export const fetchConfirmedTrips =
  (params = {}) =>
  async (dispatch) => {
    try {
      dispatch({ type: SET_LOADING, payload: true })
      const resp = await getPrivateTripList({
        limit: 100,
        page: 0,
        sortBy: 'startDate',
        ...params,
      })
      dispatch({ type: CONFIRM_TRIPS_REQUEST, payload: resp.result.data })
    } catch (error) {
      dispatch({ type: CONFIRM_TRIPS_REQUEST, payload: false })
    } finally {
      dispatch({ type: SET_LOADING, payload: false })
    }
  }
export const setConfirmedTrips = (trips) => async (dispatch) => {
  dispatch({ type: CONFIRM_TRIPS_REQUEST, payload: trips })
}

export const fetchBookings =
  (params = {}) =>
  async (dispatch) => {
    try {
      dispatch({ type: SET_LOADING, payload: true })
      const resp = await fetchBookingRequests(params)
      dispatch({ type: BOOKING_LIST_REQUEST, payload: resp.result })
    } catch (error) {
      dispatch({ type: BOOKING_LIST_REQUEST, payload: [] })
    } finally {
      dispatch({ type: SET_LOADING, payload: false })
    }
  }

export const setBookings = (payload) => (dispatch) => {
  dispatch({ type: BOOKING_LIST_REQUEST, payload: payload })
}

export const setHostFilter = (payload) => (dispatch) => {
  dispatch({ type: SET_HOST_FILTER, payload: payload })
}

export const setTravelerFilter = (payload) => (dispatch) => {
  dispatch({ type: SET_TRAVELER_FILTER, payload: payload })
}
